/**
 * imh-confetti.js
 * Konfetti ved overgang til fri frakt. Bygger på canvas-confetti.
 * Fargene og terskelen leses fra window.IMH_CONFETTI (satt i theme.liquid).
 *
 * Fyrer kun ved oppovergang (under → over grensen). Tilstanden lagres i
 * sessionStorage slik at det ikke fyrer på nytt ved sidenavigasjon.
 */
(function () {
  var CFG = window.IMH_CONFETTI || {};
  if (!CFG.enabled) return;

  var COLORS = (CFG.colors || []).filter(Boolean);
  var THRESHOLD = (parseInt(CFG.threshold, 10) || 0) * 100;
  var CART_URL = CFG.cartUrl || '/cart';
  var COUNT = parseInt(CFG.count, 10) || 200;
  var VELOCITY = parseInt(CFG.velocity, 10) || 45;
  var SPREAD = parseInt(CFG.spread, 10) || 90;
  var SCALAR = (parseInt(CFG.scalar, 10) || 14) / 10;
  var TICKS = parseInt(CFG.ticks, 10) || 400;
  var STATE_KEY = 'imhFreeShipReached';

  function burst(defaults) {
    if (typeof confetti !== 'function') return;
    function fire(ratio, opts) {
      confetti(Object.assign({}, defaults, opts, { particleCount: Math.floor(COUNT * ratio) }));
    }
    fire(0.25, { spread: SPREAD * 0.3, startVelocity: VELOCITY * 1.2 });
    fire(0.2, { spread: SPREAD * 0.67 });
    fire(0.35, { spread: SPREAD * 1.1, decay: 0.95, scalar: SCALAR * 0.8 });
    fire(0.1, { spread: SPREAD * 1.33, startVelocity: VELOCITY * 0.55, decay: 0.95, scalar: SCALAR * 1.2 });
    fire(0.1, { spread: SPREAD * 1.33, startVelocity: VELOCITY });
  }

  // Sprut fra midten av et element, horisontalt utover begge veier
  function fireFrom(element) {
    var origin = { x: 0.5, y: 0.5 };
    if (element) {
      var r = element.getBoundingClientRect();
      origin = {
        x: (r.left + r.width / 2) / window.innerWidth,
        y: (r.top + r.height / 2) / window.innerHeight
      };
    }
    // To speil-bursts: ett mot venstre, ett mot høyre, fra samme punkt
    burst({ origin: origin, angle: 60, colors: COLORS, scalar: SCALAR, drift: 0, ticks: TICKS });
    burst({ origin: origin, angle: 120, colors: COLORS, scalar: SCALAR, drift: 0, ticks: TICKS });
  }

  // Finn nærmeste relevante element å sprute fra
  function anchorElement() {
    return (
      document.querySelector('.utility-bar') ||           // announcement-bar
      document.querySelector('[data-imh-freeship]') ||    // fri frakt-teller
      document.querySelector('#cart-icon-bubble') ||      // handlekurv-ikon
      document.querySelector('.header__icon--cart') ||
      null
    );
  }

  function shippingTotal(cart) {
    var gift = 0;
    if (cart.items) {
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].gift_card) {
          gift += cart.items[i].final_line_price || cart.items[i].line_price || 0;
        }
      }
    }
    return cart.total_price - gift;
  }

  function wasReached() {
    try { return sessionStorage.getItem(STATE_KEY) === '1'; } catch (e) { return false; }
  }
  function setReached(v) {
    try { sessionStorage.setItem(STATE_KEY, v ? '1' : '0'); } catch (e) {}
  }

  function check(cart) {
    if (!THRESHOLD) return;
    var reachedNow = shippingTotal(cart) >= THRESHOLD;
    var reachedBefore = wasReached();
    if (reachedNow && !reachedBefore) {
      fireFrom(anchorElement());
    }
    setReached(reachedNow);
  }

  function refetch() {
    fetch(CART_URL + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(check)
      .catch(function () {});
  }

  // Første sjekk ved lasting: sett tilstand uten å fyre
  // (fyrer kun ved overgang, ikke ved reload mens man allerede er over)
  document.addEventListener('DOMContentLoaded', function () {
    fetch(CART_URL + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setReached(shippingTotal(cart) >= THRESHOLD); })
      .catch(function () {});
  });

  // Lytt på cart-endringer
  if (window.PUB_SUB_EVENTS && window.subscribe) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refetch);
  }
  var of = window.fetch;
  window.fetch = function () {
    var a = arguments;
    return of.apply(this, a).then(function (res) {
      try {
        var u = (a[0] && a[0].url) || a[0];
        if (typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u)) {
          setTimeout(refetch, 200);
        }
      } catch (e) {}
      return res;
    });
  };
})();
